import React from 'react';
import ViewLog from '../components/ViewLogs';

const ViewLogsPage = () => <ViewLog />;

export default ViewLogsPage;